import React, { ReactNode } from 'react';
import { FaUsers, FaSearch, FaChartBar, FaCog, FaMagic, FaEdit, 
         FaBookmark, FaDiscord, FaDice, FaPlus, 
         FaArrowUp,
         FaPalette} from 'react-icons/fa';
import '../styles/Features.css';

interface Feature {
  title: string;
  description: string;
  icon: ReactNode;
}

const features: Feature[] = [
  {
    title: "Summoner Info",
    description: "View stats of allies and enemies including rank, level, and premade information in your current game or champ select.",
    icon: <FaUsers />
  },
  {
    title: "Summoner Profiles",
    description: "Search for any summoner to view their recent matches, current rank, and level.",
    icon: <FaSearch />
  },
  {
    title: "Stats",
    description: "Deep dive into aggregate statistics from all recorded matches for any summoner, providing valuable insights.",
    icon: <FaChartBar />
  },
  {
    title: "Loadouts",
    description: "Create and manage custom loadouts containing emotes, profile icons, wards, and TFT cosmetics for quick access.",
    icon: <FaCog />
  },
  {
    title: "Auto-Import Loadouts",
    description: "Automatically switch to specific loadouts when picking certain champions, personalizing your game experience.",
    icon: <FaMagic />
  },
  {
    title: "Loadout Editor",
    description: "Editor for customizing emotes within your loadouts with ease.",
    icon: <FaEdit />
  },
  {
    title: "Runes",
    description: "Save and quickly load your favorite rune pages for different champions and playstyles.",
    icon: <FaBookmark />
  },
  {
    title: "Discord RPC",
    description: "Enhanced Discord rich-presence showing live stats and updated images.",
    icon: <FaDiscord />
  },
  {
    title: "Ultimate Bravery",
    description: "Generate Ultimate Bravery builds for fun and challenging gameplay.",
    icon: <FaDice />
  },
  {
    title: "Misc Features",
    description: "Additional quality-of-life improvements and useful tools to enhance your League experience.",
    icon: <FaPlus />
  },
  {
    title: "Auto Updater",
    description: "Automatically update the app when a new version is available.",
    icon: <FaArrowUp />
  },
  {
    title: "Themes",
    description: "Choose a theme or create your own.",
    icon: <FaPalette />
  },
];

const Features: React.FC = () => {
  return (
    <section className="features" id="features">
      <div className="container">
        <h2>Features</h2>
        <p className="features-intro">
          LeagueTools comes packed with powerful features to enhance your League of Legends experience.
        </p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features; 